import React from "react";
import { InputGroupField } from "components/common/Form";
import { CourseQuizQuestion } from "../types";
import styles from "./LikertQuestion.module.css";

interface LikertQuestionProps {
  question: CourseQuizQuestion;
}

const LikertQuestion = ({ question }: LikertQuestionProps) => {
  return (
    <div className={styles.question}>
      <div
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: question.question || "" }}
      />
      <div className={styles.answerSection}>
        <div className={styles.disagreeLabel}>
          Strongly
          <br />
          Disagree
        </div>
        {[1, 2, 3, 4, 5].map(answerValue => {
          if (!question.id) return null;

          return (
            <InputGroupField
              key={answerValue}
              type="radio"
              name={question.id}
              label={answerValue}
              value={answerValue.toString()}
              defaultChecked={answerValue === question.answers[0]?.answerValue}
              className={styles.answer}
            />
          );
        })}
        <div className={styles.agreeLabel}>
          Strongly
          <br />
          Agree
        </div>
      </div>
    </div>
  );
};

export default LikertQuestion;
